var map = {
	"./moon.svg": "Xq1a",
	"./sun.svg": "KetN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "opXP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme/hover ^\.\/.*\.svg$
// module id = opXP
// module chunks = 14